import { getCookie, setCookie } from "tpm-utils";
import getProfile from "tpm-lib/profile";

//track page views via cookies, used for showing membership marketing and metered paywall
class PageViewTracker {
	//set cookies that track _all_ page views
	setPageViewCookies(expired = true) {
		if (expired) {
			setCookie("tpm_page_views", 1, 31); //31 days = 1 month, more or less
		} else {
			const views = getCookie("tpm_page_views"); //page views
			const incremented = views ? parseInt(views) + 1 : 1; //safety check to make sure we set an actual value
			setCookie("tpm_page_views", incremented, 31);
		}
	}

	setArticleViewCookies(expired = true) {
		//track article, gallery && live-blog views only
		const classList = document.querySelector("body").classList;

		//ignore the backchannel
		if (document.body.classList.contains("category-the-backchannel")) return;

		if (
			!classList.contains("single-post") &&
			!classList.contains("single-gallery") &&
			!classList.contains("single-live-blog")
		) {
			if (expired) {
				console.log("expired! reset tpm_article_views 0");
				setCookie("tpm_article_views", 0, 31);
			}
			return;
		}
		//dont track article views for members
		if (this.profile.isPrime()) return;
		if (expired) {
			setCookie("tpm_article_views", 1, 31);
		} else {
			const views = getCookie("tpm_article_views");
			const incremented = views ? parseInt(views) + 1 : 1;
			setCookie("tpm_article_views", incremented, 31);
			if (incremented > 3 && incremented < 10) {
				const letter = document.querySelector(".js_metered-letter");
				if (letter) {
					letter.setAttribute("style", "display:block");
				}
			}
		}
	}

	get isExpired() {
		const now = new Date();
		const thisMonth = now.getMonth() + "/" + now.getFullYear();
		const expireAfter = getCookie("tpm_pv_expire_after");
		const expired = !expireAfter || expireAfter !== thisMonth; //is it a new month
		return expired;
	}

	resetCookies() {
		const now = new Date();
		setCookie(
			"tpm_pv_expire_after",
			now.getMonth() + "/" + now.getFullYear(),
			31
		);

		setCookie("tpm_page_views", 0, 31);
		setCookie("tpm_article_views", 0, 31);
	}

	trackPV() {
		const expired = this.isExpired;

		if (expired) this.resetCookies();

		this.setPageViewCookies(expired);
		this.setArticleViewCookies(expired);
		this.didtrack = true; //metered-bumper.js cares about this
	}

	constructor() {
		if (window.tpm_profile) {
			this.profile = window.tpm_profile;
			this.trackPV();
		} else {
			getProfile().then((profile) => {
				this.profile = profile;
				this.trackPV();
			});
		}
	}
}
const instance = new PageViewTracker();
window.tpm_pvt = instance;
